var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.task &&
    _vm.task.status &&
    _vm.task.status !== "error" &&
    !_vm.task.error
    ? _c(
        "div",
        [
          _vm.circular
            ? _c("v-progress-circular", {
                attrs: {
                  value: _vm.task.progress,
                  size: _vm.size,
                  indeterminate: _vm.task.status === "adapt",
                  color: _vm.color,
                },
              })
            : _c("v-progress-linear", {
                attrs: {
                  value: _vm.task.progress,
                  size: _vm.size,
                  indeterminate: _vm.task.status === "adapt",
                  color: _vm.color,
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }